import { Component, Input } from '@angular/core';
import { Mod } from '../../../../models/item-data-models';
import { BaseComponent } from '../../../base.component';

export interface ModListConfig {
  mods: Mod[];
  maxDisplayCount: number;
  showSlots: boolean;
  showTags: boolean;
  cssClass?: string;
  showMoreText?: string;
}

@Component({
  selector: 'app-mod-list',
  templateUrl: './mod-list.component.html',
  styleUrls: ['../../../../tier-list-tab/tier-tab-common.scss', '../../../label-common.scss', '../../mod-label.component.scss', './mod-list.component.scss'],
  standalone: true
})
export class ModListComponent extends BaseComponent {
  @Input({ required: true }) config!: ModListConfig;
}
